import React from 'react';
import { ThreeDots, Oval } from 'react-loader-spinner';

export const Loader = () => {
  return <ThreeDots color="#7c7ef7" height="100" width="100" />;
};
